import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Badge from "../ServiceSection/Badge";
import "./TestimonialSection.css";

const reviews = [
  {
    service: "TPO Roofing",
    name: "Michael Thompson",
    location: "Business Owner",
    text: "“I had a TPO roofing installed for my business. Ultimates Roofing delivered fast, clean work and improved our building’s energy efficiency. Highly recommended.”",
  },
  {
    service: "EPDM Roofing",
    name: "Sarah Collins",
    location: "Business Owner",
    text: "“Our warehouse EPDM roof was installed perfectly. The team was professional, on time, and the quality is outstanding. Very satisfied with the long-lasting result.”",
  },
  {
    service: "Roof Repair",
    name: "James Walker",
    location: "Homeowner",
    text: "“I had a roof leak after a storm. Ultimates Roofing responded quickly and fixed it the same day. Honest pricing and great service. I highly recommend them.”",
  },
  {
    service: "Metal Roofing",
    name: "Robert Anderson",
    location: "Business Owner",
    text: "“We upgraded to a metal roof and the results are excellent. Strong workmanship, great communication, and a durable roof that will last for decades.”",
  },
  {
    service: "Storm Damage",
    name: "Emily Carter",
    location: "Homeowner",
    text: "“After storm damage, they inspected and repaired my roof fast. They also helped with insurance. Very professional and made a stressful situation easy.”",
  },
  {
    service: "Gutter System",
    name: "David Martinez",
    location: "Homeowner",
    text: "“Our new gutter system works perfectly. No more water overflow or leaks. The installation was quick, clean, and improved our home protection a lot.”",
  },
];

const stats = [
  { value: "4.9", label: "Google Rating", icon: "bi-star-fill" },
  { value: "500+", label: "Projects Done", icon: "bi-house-check-fill" },
  { value: "100%", label: "Satisfaction", icon: "bi-shield-fill-check" },
  { value: "24h", label: "Response Time", icon: "bi-clock-fill" },
];

const TestimonialSection = () => {
  const allReviews = [...reviews, ...reviews];

  return (
    <section className="cs-section ts-section" style={{ backgroundColor: "#f8f9fa" }}>
      {/* Decorative shapes */}
      <div className="ts-bg-shape ts-shape-1"></div>
      <div className="ts-bg-shape ts-shape-2"></div>

      <div className="container position-relative">
        {/* Header */}
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <div className="cs-badge d-flex justify-content-center">
              <Badge
                className="d-flex justify-content-center text-center mx-auto"
                text={"Customer Feedback"}
              ></Badge>
            </div>
            <h2 className="cs-title ts-main-heading">
              Trusted by Hundreds of <br />
              <span className="ts-red">Property Owners</span>
            </h2>
            <div className="ts-header-line"></div>
          </div>
        </div>

        {/* Infinite Slider */}
        <div className="cs-content ts-slider-wrapper">
          <div className="ts-slider-track">
            {allReviews.map((item, index) => (
              <div className="ts-review-card" key={index}>
                <div className="ts-card-top">
                  <div className="ts-quote-icon">
                    <i className="bi bi-quote"></i>
                  </div>
                  <div className="ts-stars">
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                  </div>
                </div>

                <p className="ts-review-body">"{item.text}"</p>

                <div className="ts-card-footer">
                  <div>
                    <h5 className="ts-user-name">{item.name}</h5>
                    <span className="ts-user-meta">{item.service}</span>
                    <span className="ts-user-location">{item.location}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Stats Bar */}
        <div className="row g-0 ts-stats-row mt-5">
          {stats.map((stat, idx) => (
            <div className="col-6 col-md-3" key={idx}>
              <div className="ts-stat-box">
                <i className={`bi ${stat.icon} ts-stat-icon`}></i>
                <h3 className="ts-stat-num">{stat.value}</h3>
                <p className="ts-stat-text">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
